/** Local tokens for AI Agent page only — aligned with Collections / Dashboard chrome. */
import { DFT_BRAND, APP_PAGE_ZOOM_VAR } from '../../styles/brandPalette';

export const AI_AGENT_UI = {
  navy: DFT_BRAND.railStart,
  primary: '#1d4ed8',
  primaryDark: '#1e40af',
  canvas: DFT_BRAND.bg,
  canvasMuted: DFT_BRAND.bg,
  surface: DFT_BRAND.paper,
  surfaceMuted: DFT_BRAND.tint,
  selected: DFT_BRAND.tint,
  text: DFT_BRAND.text,
  textSecondary: DFT_BRAND.muted,
  error: '#be123c',
  success: '#15803d',
  successMuted: 'rgba(22, 163, 74, 0.08)',
  successBorder: 'rgba(22, 163, 74, 0.45)',
  errorMuted: 'rgba(190, 18, 60, 0.08)',
  errorBorder: 'rgba(190, 18, 60, 0.55)',
  border: DFT_BRAND.line,
  borderStrong: '#d1d5db',
  shadow: '0 1px 2px rgba(23, 36, 65, 0.04)',
  font: '0.875rem',
  fontSm: '0.75rem',
  fontLg: '1.5rem',
  lineHeight: 1.5,
  radius: {
    sm: 8,
    md: 12,
    lg: 14,
    xl: 14,
    pill: 999,
  },
  contentMaxWidth: 560,
  composerMaxWidth: 560,
  bubbleMaxWidth: 420,
  sidebarWidth: 248,
  /** Narrower on tablet / 1366-class CSS widths so chat still fits. */
  sidebarWidthMd: 200,
  maxInputChars: 3000,
  /**
   * Fill the tenant main pane without growing past the viewport.
   * Matches Collections-like padding (16px) and Collections page zoom.
   */
  pageHeight: {
    xs: 'calc(100dvh - 64px - 16px)',
    sm: 'calc(100dvh - 64px - 16px)',
    md: `calc(100vh / ${APP_PAGE_ZOOM_VAR} - 64px - 16px)`,
  },
  /** Forms scroll inside this cap so Quick Intents / input stay pinned. */
  formPanelMaxHeight: {
    xs: 'min(34dvh, 260px)',
    sm: 'min(36dvh, 300px)',
    md: 'min(34vh, 340px)',
  },
} as const;
